import { useMutation, useQueryClient } from '@tanstack/react-query'

import { MarkAllAsRead } from '../api/mark-as-read'

import { MutationConfig } from '@/lib/react-query'

type UseMarkAllAsReadOptions = {
  mutationConfig?: MutationConfig<typeof MarkAllAsRead>
}

export const useMarkAllAsRead = ({ mutationConfig }: UseMarkAllAsReadOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    mutationFn: MarkAllAsRead,
    onSuccess: (data, variables, context) => {
      // Invalidate notification queries to trigger refetch
      queryClient.invalidateQueries({
        queryKey: ['notifications'],
      })

      onSuccess?.(data, variables, context)
    },
    ...restConfig,
  })
}
